const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfPopulation extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfPopulation,
            "Each civilization scores 2 culture per content worker above 10.",
            {}
        )
    }
}

module.exports = ImpactOfPopulation;